import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import PageHeader from '../../header';
import CenterPanel from './centerPanel';
import RightPanelOrTopPanel from './rightPanelOrTopPanel';
import AccordionSession from './accordion';
import BottomLogo from '../../../shared/bottom-logo/content.js';
import RemoveTagConfirmationModal from './removeTagConfirmationModal';
import EditTagValueModal from './editTagValueModal';
import { queueESEvents, ESEventTypes } from 'businessLogic/logEventToElasticSearch';
import {
  selectWaitingArea,
  getWaitingArea,
  getWaitingAreaTags,
  updateWaitingAreaTagSearch,
  getAvailableTagsByNetworkId,
} from '../../../../actions/waitingArea';
import AssignTagsModal from './assignTagsModal';
import { hideWhenClickAwayOrResize } from '../../../shared/contextualMenu/content';
import { previousPage } from 'actions/navigationBar';

export default function WaitingAreaManageTagsContent(props) {
  const dispatch = useDispatch();
  const [fetchingTags, setFetchingTags] = useState(false);

  useEffect(() => {
    window.addEventListener('click', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
    window.addEventListener('resize', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
    let cbForGetWaitingArea = () => {
      let cbForGetTags = () => {
        setFetchingTags(false);
      };
      dispatch(getWaitingAreaTags(props.id, cbForGetTags));
    };
    setFetchingTags(true);
    dispatch(selectWaitingArea(props.id));
    queueESEvents(
      ESEventTypes.APICall,
      `In manage-tags: ${props.id}`,
      'eventType&apiURL',
      {
        apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + props.id + '/calls',
        browserURL: window.location.href,
      },
      null,
      true,
      'info'
    );
    dispatch(getWaitingArea(props.id, cbForGetWaitingArea));
    dispatch(getAvailableTagsByNetworkId(props.id));

    return () => {
      window.removeEventListener('click', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
      window.removeEventListener('resize', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
    };
  }, []);

  const onSearchTermInputChange = (e) => {
    console.log('WaitingAreaManageTagsContent.onSearchTermInputChange: ', e);

    if (e.target != undefined) dispatch(updateWaitingAreaTagSearch(e.target.value));
    else dispatch(updateWaitingAreaTagSearch(e));
  };

  let isWaitingAreaLoaded = props.waitingArea && props.waitingArea.id > 0;
  let modals = (
    <div>
      {props.showRemoveTagConfirmationModal && <RemoveTagConfirmationModal waitingArea={props.waitingArea} />}
      {props.showEditTagValueModal && <EditTagValueModal waitingArea={props.waitingArea} />}
    </div>
  );
  let bottomSession = <AccordionSession waitingArea={props.waitingArea} userId={props.userId} />;
  return (
    <div className="main-ui-container waiting-area-view-one new-waiting-area-view-one">
      <Container fluid as={Media} greaterThanOrEqual="computer" className="row">
        <div className="left-hand-side-panel">
          <div className="relative mrrm">
            <PageHeader
              classes="waiting-area-title"
              subHeaderClass="waiting-area-sub-title"
              title={APP.LANGUAGE.WaitingAreaManageTags.PageHeaderTitle}
              subHeader={
                props.waitingArea.name
                  ? APP.LANGUAGE.WaitingAreaManageTags.PageSubHeaderTitle.replace(
                      '##waitingAreaName##',
                      props.waitingArea.name.trim()
                    ).replace('##organisationAbbreviatedName##', props.waitingArea.organisationAbbreviatedName.trim())
                  : 'Loading...'
              }
              notRenderLogo={true}
              linkTo={
                props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                  ? `/organisational-unit/view-all`
                  : `/waiting-area/view-one/${props.waitingArea.id}`
              }
              linkText={
                props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                  ? APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText
                  : APP.LANGUAGE.WaitingAreaManageUsers.BackToWaitingAreaLinkText
              }
              linkClass={
                props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                  ? 'back-to-org-link '
                  : 'color-waiting-area-text'
              }
              linkOnClick={() => {
                dispatch(previousPage(APP.LANGUAGE.WaitingAreaManageTags.PageHeaderTitle));
              }}
              showLinkCondition={isWaitingAreaLoaded}
            >
              <span>
                <img className="ui image  mrrnull fl pdrs header-icon" src={APP.IMAGES.TagWaitingAreaIcon.default} />
              </span>
            </PageHeader>
          </div>
          <div className="manage-tags-waiting-area-container pdlm pdrm">
            <CenterPanel
              waitingArea={props.waitingArea}
              selectedTagObject={props.selectedTagObject}
              searchTerm={props.searchTerm}
              fetchingTags={fetchingTags}
              onSearchTermInputChange={(e) => onSearchTermInputChange(e)}
            />
          </div>
        </div>
        <div className="right-hand-side-panel color-right-hand-side-panel-bg">
          <RightPanelOrTopPanel
            waitingArea={props.waitingArea}
            availableTags={props.availableTags}
            showAssignTagsModal={props.showAssignTagsModal}
            bottomSession={bottomSession}
            fetchingTags={fetchingTags}
            previousPage={props.previousPage}
          />
        </div>
      </Container>
      <Container fluid as={Media} lessThan="computer">
        <div className="left-hand-side-panel-mobile">
          <PageHeader
            classes="waiting-area-title"
            subHeaderClass="waiting-area-sub-title"
            title={APP.LANGUAGE.WaitingAreaManageTags.PageHeaderTitle}
            subHeader={
              props.waitingArea.name
                ? APP.LANGUAGE.WaitingAreaManageTags.PageSubHeaderTitle.replace(
                    '##waitingAreaName##',
                    props.waitingArea.name.trim()
                  ).replace('##organisationAbbreviatedName##', props.waitingArea.organisationAbbreviatedName.trim())
                : 'Loading...'
            }
            notRenderLogo={true}
            linkTo={
              props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                ? `/organisational-unit/view-all`
                : `/waiting-area/view-one/${props.waitingArea.id}`
            }
            linkText={
              props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                ? APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText
                : APP.LANGUAGE.WaitingAreaManageUsers.BackToWaitingAreaLinkText
            }
            linkClass={
              props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                ? 'back-to-org-link '
                : 'color-waiting-area-text'
            }
            linkOnClick={() => {
              dispatch(previousPage(APP.LANGUAGE.WaitingAreaManageTags.PageHeaderTitle));
            }}
            showLinkCondition={isWaitingAreaLoaded}
          >
            <span>
              <img className="ui image  mrrnull fl pdrs header-icon" src={APP.IMAGES.TagWaitingAreaIcon.default} />
            </span>
          </PageHeader>
          <div className="right-hand-side-panel-mobile">
            <RightPanelOrTopPanel
              waitingArea={props.waitingArea}
              availableTags={props.availableTags}
              showAssignTagsModal={props.showAssignTagsModal}
              bottomSession={bottomSession}
              fetchingTags={fetchingTags}
              previousPage={props.previousPage}
            />
          </div>
          <div>
            <CenterPanel
              waitingArea={props.waitingArea}
              selectedTagObject={props.selectedTagObject}
              searchTerm={props.searchTerm}
              fetchingTags={fetchingTags}
              onSearchTermInputChange={(e) => onSearchTermInputChange(e)}
              isOnMobileOrTablet={true}
            />
          </div>
          <div className="mrtl right-hand-side-bottom-on-mobile">
            {bottomSession}
            <BottomLogo />
          </div>
        </div>
      </Container>
      {modals}
      {props.showAssignTagsModal && <AssignTagsModal waitingArea={props.waitingArea} />}
    </div>
  );
}

WaitingAreaManageTagsContent.propTypes = {
  id: PropTypes.number,
  waitingArea: PropTypes.object,
  searchTerm: PropTypes.string,
  showAssignTagsModal: PropTypes.bool,
  dispatch: PropTypes.func,
};
